export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.3e2216a6.png";